import { getByteLength } from './get-byte-length';

export function serializeString(data: string) {
  return `s:${getByteLength(data)}:"${data}";`;
}
